export const MONITORING_OBJECT_TYPE_ID = {
    GATE_IN: 'GATE_IN',
    GATE_OUT: 'GATE_OUT',
};

export const MONITORING_OBJECT_TYPE = [
    { objectType: 'GATE IN', id: 'GATE_IN' },
    { objectType: 'GATE OUT', id: 'GATE_OUT' },
];

export const FORM_STATUS = {
    ADD: 'add',
    EDIT: 'edit',
};
